import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ThemeModule } from '../@theme/theme.module';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ThemeModule,
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ThemeModule,
    ],
    providers: [
    ]
})
export class SharedModule { }
